import { AssetInventorySidebarFilterFieldEnum } from './sidebar';

export const resourceCategoriesSQLQuery = `select
    cloud, resource_category as ${AssetInventorySidebarFilterFieldEnum.resource_category}, resource_type_label as ${AssetInventorySidebarFilterFieldEnum.resource_type_label}, resource_type as ${AssetInventorySidebarFilterFieldEnum.resource_type}, total_count
    from cloud_assets_counts
    order by cloud, ${AssetInventorySidebarFilterFieldEnum.resource_category}, ${AssetInventorySidebarFilterFieldEnum.resource_type_label}, ${AssetInventorySidebarFilterFieldEnum.resource_type};`;
export const CLOUD_ASSET_NON_UNIQUE_KEY = '_cq_id';
export const CLOUD_ASSET_UNIQUE_KEY = '_cq_platform_id';
export const ROW_EDIT_ID_FIELD = CLOUD_ASSET_NON_UNIQUE_KEY;
